import React, { useContext, useState, useEffect } from "react";
import { DataContext } from "../context/DataContext";
import axios from "axios";
import { uploadFile } from "../../firebase/fileUpload";
import LoadingScreen from "../utilities/LoadingScreen";
import { useParams, useNavigate } from "react-router-dom";

const Support = () => {
  const { support, loading } = useContext(DataContext);
  const { ticketId } = useParams();
  const navigate = useNavigate();

  const supportDomain = process.env.REACT_APP_SUPPORT_DOMAIN;
  const apiDomain = process.env.REACT_APP_API_DOMAIN;

  const [isOpenTicketView, setIsOpenTicketView] = useState(true);
  const [showTicketDetail, setShowTicketDetail] = useState(false);
  const [currentTicket, setCurrentTicket] = useState(null);
  const [reply, setReply] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [imagePreview, setImagePreview] = useState(null); // For image overlay preview
  const [isloading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [replies, setReplies] = useState(null);
  const [instaUser, setInstaUser] = useState(null);
  const [toast, setToast] = useState({ show: false, message: '', type: '' }); // Add toast state

  // Log currentTicket whenever it changes
  useEffect(() => {
    if (currentTicket) {
      console.log("Updated currentTicket state: - HelpSupport.js:31", currentTicket);
    }
  }, [currentTicket]);

  // Log replies whenever they change
  useEffect(() => {
    if (replies) {
      console.log("Updated replies state: - HelpSupport.js:38", replies);
    }
  }, [replies]);

  // Hide toast after 3 seconds
  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ show: false, message: '', type: '' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  // Load specific ticket if ticketId is provided in URL
  useEffect(() => {
    if (ticketId && support && support.tickets) {
      const ticket = support.tickets.find(item =>
        item.ticket && (item.ticket.id == ticketId || item.id == ticketId)
      );
      if (ticket && !currentTicket) {
        // We'll set the ticket but not call fetchTicketDetails here to avoid initialization issues
        // The ticket detail view will show and the user can see the basic info
        setCurrentTicket(ticket.ticket);
        setReplies(ticket.replies);
        setShowTicketDetail(true);
        // Fetch ticket details including replies
        const ticketIdToUse = ticket.ticket ? ticket.ticket.id : ticket.id;
        fetchTicketDetails(ticketIdToUse);
      }
    } else if (!ticketId) {
      setShowTicketDetail(false);
      setCurrentTicket(null);
      setReplies(null);
    }
  }, [ticketId, support, currentTicket]);

  if (loading) return <LoadingScreen />;

  // Toggle between open and closed tickets view
  const toggleView = (view) => {
    setIsOpenTicketView(view);
  };

  // Open ticket detail view
  // const handleEditTicket = async (ticket) => {
  //   console.log("ticket... - HelpSupport.js:76", ticket)
  //   // Handle different ticket formats - either direct ticket or wrapped in an object
  //   const ticketIdToUse = ticket.ticket ? ticket.ticket.id : ticket.id;
  //   await fetchTicketDetails(ticketIdToUse);
  //   setCurrentTicket(ticket);
  //   setShowTicketDetail(true);
  // };

  // Back button to return to ticket list
  const handleBackToList = () => {
    navigate('/help-support');
    setShowTicketDetail(false);
    setCurrentTicket(null);
    setReplies(null);
  };

  const fetchTicketDetails = async (ticketId) => {
    try {
      const response = await axios.get(
        // `http://localhost:5050/support/ticket/${ticketId}`
        `${supportDomain}/support/ticket/${ticketId}`
      );
      setCurrentTicket(response.data.ticket);
      // Log current ticket details
      // console.log("Current Ticket Details:", response.data.ticket);
      setReplies(response.data.replies);
      // Log replies data
      // console.log("Replies Data:", response.data.replies);
      setLoading(false);
      await fetchUserDetails(response.data.ticket.user_id);
    } catch (err) {
      console.error("Error fetching ticket details: - HelpSupport.js:115", err);
      setError(err.message);
      setLoading(false);
    }
  };

  const fetchUserDetails = async (id) => {
    try {
      const resp = await axios.get(
        `${apiDomain}/api/v2/admin/getrefreshtoken?id=${id}`
      );
      const response = await axios.get(
        `${apiDomain}/api/v2/user?access_token=${resp.data.accessToken}`
      );
      const igUser = await axios.get(
        `${apiDomain}/api/v2/facebook/instagramuser?id=${response.data.instagram_business_account_id}&access_token=${resp.data.accessToken}`
      );
      setInstaUser(igUser.data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const createReply = async (replyData) => {
    try {
      const response = await axios.post(`${supportDomain}/support/reply`, {
        ticket_id: replyData.ticket_id,
        user_id: replyData.user_id,
        message: replyData.message,
        parent_reply_id: replyData.parent_reply_id || null,
        source: replyData.source,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const createAttachment = async (id, url) => {
    try {
      const response = await axios.post(
        // "http://localhost:5050/support/attachment",
        `${supportDomain}/support/attachment`,
        {
          reply_id: id,
          file_url: url,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const updateTicketStatus = async (ticketId, status) => {
    // Backend API for updating ticket status is currently missing
    throw new Error("Ticket status update API endpoint is not available");
  };

  const handleReplySubmit = async () => {
    if (currentTicket) {
      var ticket = currentTicket;
      const newReply = {
        ticket_id: ticket.id,
        user_id: ticket.user_id,
        message: reply,
        parent_reply_id: ticket.parent_reply_id || null,
        source: "admin",
      };

      console.log("new reply - HelpSupport.js:187", newReply)
      console.log("current reply - HelpSupport.js:188", currentTicket)

      try {
        var resp = await createReply(newReply);

        // Only upload attachment if one exists
        if (attachment) {
          var url = await uploadFile(attachment);
          var atresp = await createAttachment(resp.id, url);
        }

        setToast({ show: true, message: "Reply posted successfully", type: "success" });
        setReply("");
        setAttachment(null);

        // Refresh ticket details to show the new reply
        await fetchTicketDetails(ticket.id);
      } catch (error) {
        console.error("Error posting reply: - HelpSupport.js:206", error);
        setToast({ show: true, message: "Failed to post reply. Please try again.", type: "error" });
      }
    }
  };

  const handleCloseTicket = async () => {
    // Backend API for updating ticket status is currently missing
    setToast({ show: true, message: "Ticket closing feature is coming soon! Backend API implementation in progress.", type: "success" });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setAttachment(file);
    } else {
      alert("Please upload an image file (JPG, PNG, etc.)");
    }
  };

  const handleImageClick = (image) => {
    setImagePreview(image);
  };

  const closeImagePreview = () => {
    setImagePreview(null);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="lg:mr-[2vw] p-4 min-h-screen">
      {/* Toast Notification */}
      {toast.show && (
        <div
          className={`fixed top-4 right-4 z-50 px-6 py-4 rounded-lg shadow-lg text-white font-medium transition-opacity duration-300 ${
            toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'
          }`}
        >
          {toast.message}
        </div>
      )}
      <h2 className="text-3xl font-bold mb-6">Support Ticket Management</h2>

      {/* Toggle buttons for Open/Closed Tickets */}
      {/* <div className="flex space-x-4 mb-6">
        <button
          onClick={() => toggleView(true)}
          className={`px-6 py-2 rounded ${
            isOpenTicketView ? "bg-blue-600 text-white" : "bg-gray-300"
          }`}
        >
          Open Tickets
        </button>
        <button
          onClick={() => toggleView(false)}
          className={`px-6 py-2 rounded ${
            !isOpenTicketView ? "bg-blue-600 text-white" : "bg-gray-300"
          }`}
        >
          Closed Tickets
        </button>
      </div> */}

      {/* Ticket List View */}
      {!showTicketDetail && isOpenTicketView && (
        <div className="bg-white shadow-lg rounded-lg p-6">
          {/* <h3 className="text-xl font-semibold mb-4">Open Tickets</h3> */}
          <table className="w-full table-auto border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-4 py-2 text-left">Ticket ID</th>
                <th className="border px-4 py-2 text-left">User ID</th>
                <th className="border px-4 py-2 text-left">Title</th>
                <th className="border px-4 py-2 text-left">Time</th>
                <th className="border px-4 py-2 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {support &&
                support.tickets &&
                support.tickets.map((ticket) => (
                  // for deployment(server)

                  <tr key={ticket.id} className="bg-white hover:bg-gray-100">
                    <td className="border px-4 py-2">{ticket.ticket.id}</td>
                    <td className="border px-4 py-2">
                      {ticket.ticket.user_id}
                    </td>
                    <td className="border px-4 py-2">{ticket.ticket.title}</td>
                    <td className="border px-4 py-2">
                      {formatDate(ticket.ticket.created_at)}
                    </td>
                    <td className="border px-4 py-2">
                      <button
                        onClick={() => {
                          const ticketIdToUse = ticket.ticket ? ticket.ticket.id : ticket.id;
                          navigate(`/help-support/${ticketIdToUse}`);
                        }}
                        className="mr-2 px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
                      >
                        View
                      </button>
                    </td>
                  </tr>

                  // for local server

                  // <tr key={ticket.id} className="bg-white hover:bg-gray-100">
                  //   <td className="border px-4 py-2">{ticket.id}</td>
                  //   <td className="border px-4 py-2">
                  //     {ticket.user_id}
                  //   </td>
                  //   <td className="border px-4 py-2">{ticket.title}</td>
                  //   <td className="border px-4 py-2">
                  //     {formatDate(ticket.created_at)}
                  //   </td>
                  //   <td className="border px-4 py-2">
                  //     <button
                  //       onClick={() => handleEditTicket(ticket)}
                  //       className="mr-2 px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
                  //     >
                  //       View
                  //     </button>
                  //   </td>
                  // </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Ticket Detail View */}
      {showTicketDetail && currentTicket && (
        <div className="bg-white shadow-lg rounded-lg p-6">
          {/* Log currentTicket before rendering */}
          {console.log("Rendering currentTicket: - HelpSupport.js:349", currentTicket)}
          {/* Back Button and Close Ticket Button */}
          <div className="flex justify-between items-center mb-6">
            <div className="flex gap-2">
              <button
                onClick={handleBackToList}
                className="px-4 py-2 bg-gray-500 text-white rounded mb-6 hover:bg-gray-600"
              >
                Back to Tickets
              </button>
            
              <button
              
                className="px-4 py-2 bg-red-400 text-white rounded mb-6 hover:bg-blue-500 relative"
                title="Coming soon"
              >
                Close Ticket
            
              </button>
            </div>
            <h3 className="text-xl font-semibold">
              Ticket #
              {currentTicket.id} |{" "}
              <span className={`capitalize ${
                currentTicket.status === 'closed' ? 'text-red-500' : 'text-blue-500'
              }`}>
                {currentTicket.status}
              </span>
            </h3>
            <span>{formatDate(currentTicket.created_at)}</span>
          </div>
          <h4 className="text-lg font-semibold mb-2">
            Title: {currentTicket.title}
          </h4>
          <p className="mb-6">
            Description: {currentTicket.description}
          </p>

          {/* for deployment server */}

          {/* Replies Section */}
          <div className="mb-6 rounded-2xl">
            <h4 className="text-lg font-semibold mb-4">Replies</h4>
            {replies && replies.length > 0 ? (
              replies.map((item, index) => {
                const reply = item.reply || item; // Handle wrapped and direct replies
                const attachments = item.attachments;

                return (
                  <div
                    key={index}
                    className="mb-4 border-2 py-2 px-4 rounded-xl"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2 pl-2 pr-2 py-1 rounded-full border border-gray-300">
                        {instaUser && instaUser.profile_picture_url && (
                          <img
                            src={instaUser.profile_picture_url}
                            alt="/img"
                            className="w-10 h-10 rounded-full"
                          />
                        )}
                        <p className="font-semibold capitalize">
                          {reply.source === "user"
                            ? instaUser?.username || "User"
                            : reply.source === "sponsor"
                            ? "Sponsor"
                            : "Admin"}
                        </p>
                      </div>
                    </div>
                    <p className="capitalize font-normal text-gray-800 ml-2">
                      {reply.message}
                    </p>
                    {attachments && attachments.length > 0 && (
                      <div className="my-4 ml-2 flex gap-2 flex-wrap">
                        {attachments.map((attachment, attachmentIndex) => (
                          <img
                            key={attachmentIndex}
                            src={attachment.file_path}
                            alt="attachment"
                            className="w-32 h-32 object-cover cursor-pointer rounded-md"
                            onClick={() =>
                              handleImageClick(attachment.file_path)
                            }
                          />
                        ))}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <p className="text-gray-500">No replies yet.</p>
            )}
          </div>

          {/* for loacl server */}
          {/* <div className="mb-6 rounded-2xl">
            <h4 className="text-lg font-semibold mb-4">User Query</h4>
            {replies &&
              replies.map((reply, index) => (
                <div key={index} className="mb-4 border-2 py-2 px-4 rounded-xl">
                  <div className="flex items-center justify-between mb-2 ">
                    <div className="flex items-center gap-2 pl-2 pr-2 py-1 rounded-full border border-gray-300">
                      {instaUser && (
                        <img
                          src={instaUser.profile_picture_url}
                          alt="/img"
                          className="w-10 h-10 rounded-full"
                        />
                      )}
                      <p className="font-semibold capitalize">
                        {reply.reply.source === "user"
                          ? `${instaUser && instaUser.username}`
                          : "sponsor"
                          ? `${instaUser && instaUser.username}`
                          : "Admin"}
                      </p>
                    </div>
                  </div>
                  <p className="capitalize font-normal text-gray-800 ml-2">
                    {reply.reply.message}
                  </p>
                  <div className="my-4 ml-2">
                    {reply.attachments &&
                      reply.attachments.map((image) => (
                        <img
                          key={image.file_path}
                          src={image.file_path}
                          alt="attachment"
                          className="w-32 h-32 object-cover cursor-pointer rounded-md"
                          onClick={() => handleImageClick(image.file_path)}
                        />
                      ))}
                  </div>
                </div>
              ))}
          </div> */}

          {/* Admin Reply Form */}
          <div className="bg-gray-100 p-4 rounded-lg">
            <h4 className="font-semibold mb-2">Reply</h4>
            <textarea
              className="w-full p-2 mb-4 border border-gray-300 rounded"
              rows="4"
              value={reply}
              onChange={(e) => setReply(e.target.value)}
              placeholder="Type your reply here"
            />
            <input type="file" onChange={handleFileChange} className="mb-4" />
            <div className="flex justify-end">
              <button
                onClick={handleReplySubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Submit Reply
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Image Overlay */}
      {imagePreview && (
        <div
          className="fixed inset-0 left-8 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={closeImagePreview}
        >
          <img
            src={imagePreview}
            alt="Full-size preview"
            className="max-w-full max-h-full"
          />
        </div>
      )}
    </div>
  );
};

export default Support;
